// extracted by mini-css-extract-plugin
export var dropdownButton = "_22-0";
export var fullWidthDropdownButton = "_22-1";
export var icon = "_22-3";
export var iconPlaceholder = "_22-2";
export var menuItemRow = "_22-5";
export var shortcutContainer = "_22-4";